import { useEffect } from 'react';
import { useLocation } from '@tanstack/react-router';

import { initMetaPixel, trackPageView } from './meta-pixel';

// Module-level so StrictMode remounts and same-path rerenders never
// double-count a PageView.
let lastTrackedPathname: string | null = null;

export const useMetaPixelPageView = () => {
  const pathname = useLocation({ select: (location) => location.pathname });

  useEffect(() => {
    if (pathname === lastTrackedPathname) return;
    lastTrackedPathname = pathname;
    initMetaPixel();
    trackPageView();
  }, [pathname]);
};

/** Test-only: reset module state between tests. */
export const __resetPageViewForTests = () => {
  lastTrackedPathname = null;
};
